import { Product } from "./data/products";

export interface AppDetailPageProps {
  product: Product;
}

export const AppDetailPage: React.FC<AppDetailPageProps> = ({ product }) => {
  return (
    <div
      id={`div-application-app-${product.id}`}
      className="div application-app-detail"
    >
      <section className="block block-tight">
        <div className="wrap">
          <div className="detail-hero">
            <div className="icon-lg">
              <img src={product.icon} alt={`${product.name} app icon`} />
            </div>
            <div>
              <div className="eyebrow">{product.platforms}</div>
              <h3 className="section-head" style={{ marginBottom: "6px" }}>
                {product.name}
              </h3>
              <p className="lede" style={{ margin: 0 }}>
                {product.lede}
              </p>
              <div className="badge-row">
                {product.comingSoon ? (
                  <span className="store-badge coming-soon">
                    <span className="dot"></span>
                    Coming soon to the App Store
                  </span>
                ) : (
                  <a
                    className="store-badge ready"
                    href={product.appStoreUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="dot"></span>
                    Download on the App Store
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="feature-list">
            {product.features.map((feature) => (
              <div className="feature-item" key={feature.title}>
                <div className="f-title">{feature.title}</div>
                <p>{feature.body}</p>
              </div>
            ))}
          </div>

          <div className="shot-row">
            {product.screenshots.map((screenshot) => (
              <div key={screenshot.caption}>
                <div className="shot-frame">
                  <img src={screenshot.src} alt={screenshot.alt} />
                </div>
                <div className="shot-cap">{screenshot.caption}</div>
              </div>
            ))}
          </div>

          {product.comingSoon && (
            <p className="lede" style={{ marginTop: "32px" }}>
              {/* Per-product, because this component is generic: the copy here used
                  to name SusLink outright, so every later coming-soon product would
                  have rendered SusLink's sentence on its own page. The fallback is
                  deliberately the weaker claim — "finished and in testing" is not
                  true of everything that has not shipped yet. */}
              {product.comingSoonNote ??
                `This page will link to the App Store the day ${product.name} is released.`}
            </p>
          )}

          <div className="privacy-note">
            <span className="mono">PRIVACY POLICY</span>
            <a href={product.privacyPath}>{product.privacyPath}</a>
            <span>
              — how {product.name} handles your information, in full.
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};
